import { useOrganizationPreference } from '@melio/platform-api';

export const useIsMsnDashboardDisplay = () => {
  const { data: organization } = useOrganizationPreference({
    id: 'vendorDashboardDisplay',
  });

  return organization?.value === 'msn_portal';
};
